export class LexError extends Error {
    pos;
    constructor(message, pos) {
        super(message);
        this.pos = pos;
        this.name = "LexError";
    }
}
const isSpace = (c) => c === " " || c === "\t" || c === "\n" || c === "\r";
/** A value may start with a word character, a quote or a brace: `-Fixed`, `-"a b"`, `-{In Progress}`. */
const canStartAtom = (c) => !isSpace(c) && c !== ":" && c !== "," && c !== "(" && c !== ")" && c !== "}";
const isWordBreak = (c) => isSpace(c) || c === ":" || c === "," || c === "(" || c === ")" || c === '"' || c === "{" || c === "}";
export function lex(input) {
    const out = [];
    let i = 0;
    const n = input.length;
    while (i < n) {
        const c = input[i];
        if (isSpace(c)) {
            i++;
            continue;
        }
        const start = i;
        switch (c) {
            case ":":
                out.push({ kind: "colon", text: ":", start, end: ++i });
                continue;
            case ",":
                out.push({ kind: "comma", text: ",", start, end: ++i });
                continue;
            case "(":
                out.push({ kind: "lparen", text: "(", start, end: ++i });
                continue;
            case ")":
                out.push({ kind: "rparen", text: ")", start, end: ++i });
                continue;
            case '"': {
                let j = i + 1;
                let text = "";
                while (j < n && input[j] !== '"') {
                    if (input[j] === "\\" && j + 1 < n) {
                        text += input[j + 1];
                        j += 2;
                    }
                    else {
                        text += input[j];
                        j++;
                    }
                }
                if (j >= n)
                    throw new LexError("unterminated string", start);
                out.push({ kind: "quoted", text, start, end: j + 1 });
                i = j + 1;
                continue;
            }
            case "{": {
                const j = input.indexOf("}", i + 1);
                if (j < 0)
                    throw new LexError("unterminated brace", start);
                out.push({ kind: "braced", text: input.slice(i + 1, j).trim(), start, end: j + 1 });
                i = j + 1;
                continue;
            }
            case "}":
                throw new LexError("unexpected }", start);
        }
        if (c === "." && input[i + 1] === ".") {
            out.push({ kind: "dotdot", text: "..", start, end: i + 2 });
            i += 2;
            continue;
        }
        if (c === "-" && i + 1 < n && canStartAtom(input[i + 1])) {
            out.push({ kind: "minus", text: "-", start, end: ++i });
            continue;
        }
        if (c === "#" && i + 1 < n && !isSpace(input[i + 1])) {
            out.push({ kind: "hash", text: "#", start, end: ++i });
            continue;
        }
        let j = i;
        while (j < n && !isWordBreak(input[j])) {
            // ".." inside a word ends it (range operator), but "1.5" must stay a word.
            if (input[j] === "." && input[j + 1] === ".")
                break;
            j++;
        }
        if (j === i)
            throw new LexError(`unexpected character ${JSON.stringify(c)}`, start);
        out.push({ kind: "word", text: input.slice(i, j), start, end: j });
        i = j;
    }
    out.push({ kind: "eof", text: "", start: n, end: n });
    return out;
}
//# sourceMappingURL=lexer.js.map